<template>
	<custom-button class="primary"><slot></slot></custom-button>
</template>

<script>
import CustomButton from "./CustomButton";

export default {
	props: {
		btnType: String,
	},
	components: {
		CustomButton,
	},
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/main.scss";

.primary {
	font-weight: bold;
	padding: 1em 2.5em;
	background-color: $red;
	$shadow-size: 3px;
	$shadow-color: transparentize($red-dark, 0.4);
	transition: 0.5s;
	box-shadow: 0px $shadow-size $shadow-color;
	&:hover:enabled,
	&:not(.disabled):hover {
		$offset: 3px;
		transform: translateY(-($offset));
		box-shadow: 0px ($shadow-size + $offset) $shadow-color;
		background-color: lighten($red, 5%);
		transition: $trd-m;
	}
	&:active:enabled,
	&:not(.disabled):active {
		background-color: $red-darker;
		box-shadow: 0px -1px darken($red-darker, 20%);
		transform: translateY(2px);
	}
	&:disabled,
	&.disabled {
		background-color: $red-darker;
		color: $red-lighter;
		cursor: not-allowed;
		&:hover {
			background-color: $red-darker;
		}
	}
}
</style>
